module.exports = __webpack_public_path__ + "img/hadara.65dc77c0.svg";